import React, { Component } from "react";
import firebase from "../../firebase";
import {
  Segment,
  Accordion,
  Icon,
  Header,
  Image,
  List,
  Embed
} from "semantic-ui-react";

export default class MetaPanel extends Component {
  state = {
    channel: this.props.currentChannel,
    privateChannel: this.props.isPrivateChannel,
    activeIndex: 0,
    user: this.props.currentUser,
    users: [],
    activeChannel: "",
    presenceChannelRef: firebase.database().ref("presenceChannel"),
    hashUser: "",
    isMounted: false,
    likesRef: firebase.database().ref("likes")
  };

  componentDidMount() {
    this.state.isMounted = true;

    //1時間たったらPresenceChannelを削除
    setTimeout(this.deletePresenceChannel, 60 * 60000);

    this.state.channel && this.displayCurrentUsers(this.state.channel);
  }

  componentWillUnmount() {
    this.state.isMounted = false;
    this.removeListeners();
  }

  setActiveIndex = (event, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  formatCount = num => (num > 1 || num === 0 ? `${num} posts` : `${num} post`);

  formatCountLikes = num => (num > 1 ? `${num} likes` : `${num} like`);

  formatContent = str =>
    str && typeof str === "string" ? str.substr(0, 25) : str;

  displayTopPosters = posts =>
    Object.entries(posts)
      .sort((a, b) => b[1]["count"] - a[1]["count"])
      .map(([key, val], i) => (
        <List.Item key={i}>
          <Image avatar src={val.avatar} />
          <List.Content>
            <List.Header as="a">{key}</List.Header>
            <List.Description>{this.formatCount(val.count)}</List.Description>
          </List.Content>
        </List.Item>
      ))
      .slice(0, 5);

  displayTopLikes = posts =>
    Object.entries(posts)
      .sort((a, b) => b[1]["count"] - a[1]["count"])
      .map(
        ([key, val], i) =>
          val.count > 0 && (
            <List.Item key={i}>
              <Image avatar src={val.avatar} />
              <List.Content>
                {/* <List.Header as="a">{key}</List.Header> */}
                <List.Header as="a">{val.userName}</List.Header>
                <List.Description>
                  {this.formatCountLikes(val.count)}
                </List.Description>
                <List.Description>
                  {this.formatContent(val.content)}
                </List.Description>
              </List.Content>
            </List.Item>
          )
      )
      .slice(0, 10);

  displayCurrentUsers = channel => {
    let loadedUsers = [];
    let hash = {};
    this.state.presenceChannelRef.child(channel.id).on("value", snap => {
      if (snap.val()) {
        for (const key in snap.val()) {
          //console.log(snap.val()[key].avatar);

          if (loadedUsers.indexOf(key) == -1) {
            hash[key] = snap.val()[key].avatar;
            loadedUsers.push(key);
          }
        }
        if (this.state.isMounted) {
          this.setState({ users: loadedUsers });
          this.setState({ hashUser: hash });
        }
      }
    });
  };

  removeListeners = () => {
    this.state.presenceChannelRef.off();
  };

  rederUser(users) {
    // console.log(users);
    let arr = [];
    users &&
      users.map((val, i) =>
        arr.push(
          <List.Item key={i}>
            <Image avatar src={val.avatar} />
            <List.Content>
              <List.Header as="a">{val}</List.Header>
            </List.Content>
          </List.Item>
        )
      );

    return arr;
  }
  rederUser2(users) {
    // console.log(users);
    let arr = [];
    for (const key in users) {
      users &&
        arr.push(
          <List.Item key={key}>
            <Image avatar src={users[key]} />
            <List.Content>
              <List.Header as="a">{key}</List.Header>
            </List.Content>
          </List.Item>
        );
    }

    return arr;
  }

  deletePresenceChannel = () => {
    this.props.currentChannel && this.state.presenceChannelRef.remove(),
      console.log("deleted!");
  };

  render() {
    const {
      activeIndex,
      privateChannel,
      channel,
      users,
      activeChannel
    } = this.state;
    const { userPosts, userLikes } = this.props;

    if (privateChannel) return null;

    return (
      <Segment loading={!channel} className="metaPanel">
        <Header as="h3" attached="top">
          About # {channel && channel.name}
        </Header>
        <Accordion styled attached="true">
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="info" />
            部屋の説明
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
            {channel && channel.details}
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="user circle" />
            発言数トップ5
          </Accordion.Title>

          <Accordion.Content active={activeIndex === 1}>
            <List>{userPosts && this.displayTopPosters(userPosts)}</List>
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 2}
            index={2}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="heart" />
            いいねトップ10
          </Accordion.Title>
          <Accordion.Content
            active={activeIndex === 2}
            style={{
              height: "300px",
              overflowY: "auto"
            }}
          >
            <List>{userLikes && this.displayTopLikes(userLikes)}</List>
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 3}
            index={3}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="users" />
            参加中
          </Accordion.Title>
          <Accordion.Content
            active={activeIndex === 3}
            style={{
              height: "400px",
              overflowY: "auto"
            }}
          >
            {/* <List>{this.rederUser(this.state.users)}</List> */}
            <List>{this.rederUser2(this.state.hashUser)}</List>
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 4}
            index={4}
            onClick={this.setActiveIndex}
          >
            <Icon name="dropdown" />
            <Icon name="video" />
            Live
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 4}>
            {/* <Embed
              id={channel && channel.live}
              placeholder="/images/image-16by9.png"
              source="youtube"
              height="400px"
            /> */}
            <Embed
              icon="right circle arrow"
              placeholder="/images/image-16by9.png"
              url={channel && channel.live}
            />
          </Accordion.Content>
        </Accordion>
      </Segment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MetaPanel/MetaPanel.js